import InvoiceForm from "../components/invoice/InvoiceForm";

const InvoiceReadPage = () => {
  return (
    <>
      <InvoiceForm readonly={true} />
    </>
  );
};

export default InvoiceReadPage;
